import React from "react";
import { Mail, Sparkles } from "lucide-react";
import { useI18n } from "../i18n";

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-3 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-9 h-9 rounded-md bg-white text-slate-900 grid place-items-center">
                <Sparkles className="w-4 h-4" />
              </span>
              <span className="font-display text-lg font-semibold text-white">
                Smile<span className="text-sky-400">Automate</span>
              </span>
            </div>
            <p className="max-w-md text-slate-400 leading-relaxed">{t.footer.tagline}</p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
              {t.footer.contact}
            </div>
            <a
              data-testid="footer-email"
              href="mailto:johnnynarcisop6@gmail.com"
              className="inline-flex items-center gap-2 text-white hover:text-sky-400 transition-colors"
            >
              <Mail className="w-4 h-4" /> johnnynarcisop6@gmail.com
            </a>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} SmileAutomate. {t.footer.legal}</div>
          <div>Made with care in Spain</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
